export enum ScoreBreakdownKind {
  SCORED = "scored",
  UNCLEAR = "unclear",
}
